export function searchGlossary (params = {})
{
    var url = new URL(window.location.origin + '/wp-json/ncel/v1/glossary')
    Object
        .keys(params)
        .forEach(key => url.searchParams.append(key, params[key]))

    return fetch(url);
}
